import React, { useContext } from 'react';
import { AppContext } from 'App.context.js';
import DefaultLayout from 'Components/DefaultLayout/DefaultLayout.jsx';
import ContentBox from 'Components/common/ContentBox/ContentBox.jsx';
import AppSelector from 'Components/common/AppSelector/AppSelector';

import usePVConfigHook from './PVConfig.hook.js';
import PoliceAPI from '../Platforms/PoliceAPI/PoliceAPI.jsx';
import PoliceSFTP from '../Platforms/PoliceSFTP/PoliceSFTP.jsx';
import PoliceS3 from '../Platforms/PoliceS3/PoliceS3.jsx';
import Colors from 'constants/Colors.js';
import S3UserConfig from '../Platforms/S3User/s3userConfig.jsx';

export default function PVConfig() {
  const { state, actions } = usePVConfigHook();
  const {
    appActions: { translate },
  } = useContext(AppContext);

  const renderPlatform = () => {
    switch (state.selectedOptionConnection) {
      case 'SFTP':
        return <PoliceSFTP type="PV" />;
      case 'API':
        return <PoliceAPI type="PV" />;
      case 'S3':
        return <PoliceS3 type="PV" />;
      default:
        return null;
    }
  };

  return (
    <DefaultLayout title={translate('layout.policeReportConfig')} enableAllHotels={false}>
      {state.suscription ? (
        <>
          <ContentBox title={translate('policeReport.connectionType')}>
            <AppSelector
              title={translate('policeReport.chooseConnectionType')}
              value={state.selectedOptionConnection}
              options={state.connectionOptions}
              onOptionSelected={actions.handleSelectConnection}
            />
            {renderPlatform()}
          </ContentBox>

          {state.selectedOptionConnection === 'S3' && (
            <ContentBox title={translate('policeReport.s3UserConfig.title')}>
              <S3UserConfig />
            </ContentBox>
          )}
        </>
      ) : (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            width: '100%',
            alignItems: 'center',
          }}
        >
          <div
            style={{
              backgroundColor: Colors.white,
              borderRadius: 16,
              padding: 16,
              maxWidth: 600,
            }}
          >
            <div style={{ fontWeight: 'bold' }}>
              {translate('policeReport.missingSuscription.title')}
            </div>
            <div>{translate('policeReport.missingSuscription.description')}</div>
            {state.sendSuscriptionRequestEnabled && (
              <div style={{ display: 'flex', justifyContent: 'right', marginTop: 8 }}>
                <AppButton
                  text={translate('policeReport.missingSuscription.send')}
                  action={() => actions.requestGuestlinkFunctionality()}
                />
              </div>
            )}
          </div>
        </div>
      )}
    </DefaultLayout>
  );
}
